import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { InputWrap, InputField, InputCheckbox } from "components";
import { observer, inject } from 'mobx-react';
import {
    DOWNLOAD_ACCESSOR_SEARCH_BOX, DATE_FORMAT, DATE_PLACHOLDER_FORMAT, DATE_SEPARATE,
    CONFIG_FILE_EDITION, EMPTY_FORMAT_CELL, PREBUILT_MODEL_CODE, PREBUILT_GROUP_CODE,
    AI_SETTING_NONE
} from '../../core/utils/constants';
import DateComponent from '../../components/DateComponent'
import "./style.scss";
import moment from 'moment'
@inject('commonStore', 'documentsDownloadStore', 'modalStore')
@observer
class SearchBox extends Component {
    tableOriginalSize = 0;
    constructor(props) {
        super(props);
        const { savedData } = this.props;
        this.state = {
            filterData: {},
            errors: {
                fromTime: "",
                toTime: "",
                hasError: () => {
                    return (this.state?.errors?.fromTime !== "" || this.state?.errors?.toTime !== "")
                }
            },
            isCollapseOut: (savedData?.isCollapseOut === true) ? savedData?.isCollapseOut : false,
        };
    }
    /**
     * handleFilterDataChange
     * handle all filter data change
     * update current state
     * 
     * @param {string} name name of the field
     * @param {string} value value of the field
     * 
     * @returns Null setState and rerender component
     */
    handleFilterDataChange = (name, value) => {
        const { documentsDownloadStore } = this.props;
        if ([DOWNLOAD_ACCESSOR_SEARCH_BOX.TO_TIME, DOWNLOAD_ACCESSOR_SEARCH_BOX.FROM_TIME].includes(name)) {
            if (value) {
                let timeStamp = moment(value).format(DATE_FORMAT.time_stamp)
                this.validationDateData(name, timeStamp)
            }
        }
        if ([DOWNLOAD_ACCESSOR_SEARCH_BOX.FORM_GROUP_ID].includes(name)) {
            // 帳票グループ指定
            let data = {}
            if (value.includes(',')) {
                // AI設定の場合はグループと定義両方指定
                let formGroupId = value.split(',')[0];
                let configFileId = value.split(',')[1];

                documentsDownloadStore.filterAIDefinitationsByGroup();
                data[DOWNLOAD_ACCESSOR_SEARCH_BOX.FORM_GROUP_ID] = formGroupId;
                data[DOWNLOAD_ACCESSOR_SEARCH_BOX.CONFIG_FILE_ID] = configFileId;
                documentsDownloadStore.updateTempSearchBoxFiler(data);
                return;
            }
            documentsDownloadStore.getDefinitationsByGroup(value);
            documentsDownloadStore.resetConfigFileId();
            data[name] = value;
            documentsDownloadStore.updateTempSearchBoxFiler(data);
            return;
        }
        if ([DOWNLOAD_ACCESSOR_SEARCH_BOX.CONFIG_FILE_ID].includes(name)) {
            // 帳票定義 (またはAI設定) 選択時
            let data = {}
            if (value.includes("ai-setting,")) {
                // AI設定が選択された場合の分岐
                data[DOWNLOAD_ACCESSOR_SEARCH_BOX.AI_SETTING_NAME] = value.replace("ai-setting,", "");
                if (documentsDownloadStore.tempFilterData?.formGroupId != PREBUILT_GROUP_CODE.AI) {
                    // 帳票グループフィルタがAI出ない場合は帳票定義をクリア
                    data[DOWNLOAD_ACCESSOR_SEARCH_BOX.CONFIG_FILE_ID] = null;
                }
            } else {
                // 通常の帳票定義
                data[name] = value;
                data[DOWNLOAD_ACCESSOR_SEARCH_BOX.AI_SETTING_NAME] = null;
            }
            documentsDownloadStore.updateTempSearchBoxFiler(data);
            return;
        }
        if ([DOWNLOAD_ACCESSOR_SEARCH_BOX.TEAM_ID].includes(name)) {
            this.props.commonStore.teamStore.getUsersByTeamId(value);
            this.props.documentsDownloadStore.resetUserId();
        }
        let data = {}
        data[name] = value;
        documentsDownloadStore.updateTempSearchBoxFiler(data);
    }

    /**
     * componentWillMount
     * get definitions of user
     * 
     */
    componentWillMount() {
        this.props.documentsDownloadStore.getDefinitationsInTeam();
        this.props.documentsDownloadStore.getAllDefinitationsGroupInTeam();
        this.props.documentsDownloadStore.getAiSettings();
        this.props.commonStore.teamStore.getTeamOfUser();
        this.props.commonStore.teamStore.getUsersInSameTeams();
    }

    componentDidMount() {
        const { isCollapseOut } = this.state;
        document.getElementById("collapsible").checked = isCollapseOut;
        this.documentHandleCollapse(!isCollapseOut);
        let tableContainerHeight = document.getElementsByClassName("table-container");
        if (tableContainerHeight && tableContainerHeight[0]) {
            this.tableOriginalSize = tableContainerHeight[0].offsetHeight;
        }

        this.tableHandler();
    }

    /**
     * validationDateData
     * 
     * rules:
     * fromTime is required when toTime has value
     * toTime is required when fromTime has value
     * fromTime is smaller than fromTime
     * 
     * @param {string} currentField name of the field
     * @param {string} newValue value of the field
     * 
     * @returns set errors setState and rerender component
     */
    validationDateData = (currentField, newValue) => {
        let filterData = this.state.filterData
        let errors = this.state.errors;

        errors.fromTime = "";
        errors.toTime = "";
        if (newValue) {
            if (currentField === DOWNLOAD_ACCESSOR_SEARCH_BOX.FROM_TIME && filterData.toTime && newValue > filterData.toTime) {
                errors.fromTime = 'search_box.from_time_greater_to_time';
            }
            if (currentField === DOWNLOAD_ACCESSOR_SEARCH_BOX.TO_TIME && filterData.fromTime && filterData.fromTime > newValue) {
                errors.toTime = 'search_box.from_time_greater_to_time';
            }
        }
        this.setState({ errors: { ...this.state.errors, ...errors } })
    }

    documentHandleCollapse(isCollapseOut) {
        let element = document.getElementById("collapse-header");
        if (isCollapseOut && element) {
            element.classList.add("collapse_in");
            element.classList.remove("collapse_out");
        } else {
            element.classList.remove("collapse_in");
            element.classList.add("collapse_out");
        }
    }

    collapseHander = (e) => {
        const { isCollapseOut } = this.state;
        const { documentsDownloadStore } = this.props;

        documentsDownloadStore.updateSearchBoxCollapse(!isCollapseOut);
        this.documentHandleCollapse(isCollapseOut);
        document.getElementById("collapsible").checked = !isCollapseOut
        this.setState({ isCollapseOut: !isCollapseOut });
        this.tableHandler();
    }

    tableHandler = () => {
        // compute table.
        // search box height
        let collapsibleContentHeight = document.getElementsByClassName("collapsible-content");
        if (collapsibleContentHeight && collapsibleContentHeight[0]) {
            let tableContainerHeight = document.getElementsByClassName("table-container");
            if (tableContainerHeight && tableContainerHeight[0]) {
                let tableHeight = tableContainerHeight[0].offsetHeight;
                if (collapsibleContentHeight[0].offsetHeight === 0) {
                    tableContainerHeight[0].style.height = this.tableOriginalSize - 2 + "px";
                } else {
                    tableContainerHeight[0].style.height = tableHeight - collapsibleContentHeight[0].offsetHeight + 10.7 + "px";
                }

                // compute for table body
                let table = document.getElementsByTagName("table");
                if (table && table[0]) {
                    let tableHead = document.getElementsByTagName("thead");
                    if (tableHead && tableHead[0]) {
                        let tableBody = document.getElementsByTagName("tbody");
                        if (tableBody && tableBody[0]) {
                            let tableBodyHeight = table[0].offsetHeight - tableHead[0].offsetHeight;
                            tableBody[0].style.height = tableBodyHeight + "px";
                        }
                    }
                }
            }
        }
    }

    getFormGroupValue = () => {
        const { documentsDownloadStore: { tempFilterData } } = this.props;
        if (tempFilterData?.formGroupId == PREBUILT_GROUP_CODE.AI) {
            return `${tempFilterData?.formGroupId},${tempFilterData?.configFileId}`;
        } else {
            return tempFilterData?.formGroupId ? tempFilterData?.formGroupId : "";
        }
    }

    getConfigFileValue = () => {
        const { documentsDownloadStore: { tempFilterData } } = this.props;
        if (tempFilterData?.aiSettingName) {
            return `ai-setting,${tempFilterData?.aiSettingName}`;
        } else {
            return tempFilterData?.configFileId ? tempFilterData?.configFileId : "";
        }
    }

    /**
     * render
     * render search box
     * 
     */
    render() {
        const { t, commonStore: { teamStore } } = this.props;
        return (
            <div className="search-form">
                <div id="collapse-header" className="collapse-header" onClick={() => this.collapseHander()}>
                    <h4 className="sb-form-title">{t("download_search_box.narrowing_conditions")}</h4>
                </div>
                <input id="collapsible" className="toggle" type="checkbox"></input>

                <div className="collapsible-content row document-search-pannel">
                    <div className="row row-1st" style={{ display: "flex" }}>
                        <div style={{ display: "flex", lineHeight: "30px" }}>
                            <label>{t("download_search_box.file_name")}</label>
                            <InputField
                                type="text"
                                name={DOWNLOAD_ACCESSOR_SEARCH_BOX.FILE_NAME_INPUT}
                                placeholder={t("download_search_box.file_name_place_holder")}
                                onChange={this.handleFilterDataChange}
                                value={this.props.documentsDownloadStore.tempFilterData?.filenameOriginal}
                            />
                        </div>

                        <div className="l20">
                            <label>{t("download_search_box.formGroup")}</label>
                            <select className="select download-select"
                                onChange={(e) => this.handleFilterDataChange(DOWNLOAD_ACCESSOR_SEARCH_BOX.FORM_GROUP_ID, e?.target?.value)}
                                value={this.getFormGroupValue()}
                            >
                                <option key={"null"} value={"null"}>{t("download_search_box.all_definition_file")}</option>
                                {
                                    this.props?.documentsDownloadStore?.listGroupDefinitions.filter((item) => {
                                        return item?.id != PREBUILT_GROUP_CODE.AI
                                    }).map((item) => {
                                        if (item?.id == PREBUILT_GROUP_CODE.PREBUILT) {
                                            return <option key={item?.id} value={item?.id}>{t("documents_download.prebuilt")}</option>
                                        }
                                        return <option key={item?.id} value={item?.id}>{item?.groupName}</option>
                                    })
                                }
                                {
                                    this.props?.documentsDownloadStore?.listAllDefinitionsCache.filter((item) => {
                                        return item?.formGroupId == PREBUILT_GROUP_CODE.AI
                                    }).map((item) => {
                                        let id = `${PREBUILT_GROUP_CODE.AI},${item?.id}`;
                                        switch (item?.id) {
                                            case PREBUILT_MODEL_CODE.CLAUDE_3_5:
                                                return <option key={id} value={id}>{t("documents_download.prebuilt_claude_3_5")}</option>
                                            case PREBUILT_MODEL_CODE.CLAUDE_3_7:
                                                return <option key={id} value={id}>{t("documents_download.prebuilt_claude_3_7")}</option>
                                            case PREBUILT_MODEL_CODE.CLAUDE_4_5:
                                                return <option key={id} value={id}>{t("documents_download.prebuilt_claude_4_5")}</option>
                                            case PREBUILT_MODEL_CODE.CLAUDE_4_6:
                                                return <option key={id} value={id}>{t("documents_download.prebuilt_claude_4_6")}</option>
                                            case PREBUILT_MODEL_CODE.CLAUDE_5:
                                                return <option key={id} value={id}>{t("documents_download.prebuilt_claude_5")}</option>
                                            case PREBUILT_MODEL_CODE.GEMINI_3_1_PRO:
                                                return <option key={id} value={id}>{t("documents_download.prebuilt_gemini_3_1_pro")}</option>
                                            case PREBUILT_MODEL_CODE.GEMINI_3_5_FLASH:
                                                return <option key={id} value={id}>{t("documents_download.prebuilt_gemini_3_5_flash")}</option>
                                            case PREBUILT_MODEL_CODE.GEMINI_3_7_FLASH:
                                                return <option key={id} value={id}>{t("documents_download.prebuilt_gemini_3_7_flash")}</option>
                                            default:
                                                return <option key={id} value={id}>{item?.configName}</option>
                                        }
                                    })
                                }
                            </select>
                        </div>

                        <div className="l20">
                            <label>{t("download_search_box.definition_file")}</label>
                            <select className="select download-select"
                                onChange={(e) => this.handleFilterDataChange(DOWNLOAD_ACCESSOR_SEARCH_BOX.CONFIG_FILE_ID, e?.target?.value)}
                                value={this.getConfigFileValue()}
                            >
                                <option key={"null"} value={"null"}>{t("download_search_box.all_definition_file")}</option>
                                {
                                    this.props?.documentsDownloadStore?.listAllDefinitions.filter((item) => {
                                        return item?.formGroupId != PREBUILT_GROUP_CODE.AI
                                    }).map((item) => {
                                        if (item?.edition == CONFIG_FILE_EDITION.PREBUILT) {
                                            switch (item?.id) {
                                                case PREBUILT_MODEL_CODE.INVOICE:
                                                    return <option key={item?.id} value={item?.id}>{t("documents_download.prebuilt_invoice")}</option>
                                                case PREBUILT_MODEL_CODE.RECEIPT:
                                                    return <option key={item?.id} value={item?.id}>{t("documents_download.prebuilt_receipt")}</option>
                                                case PREBUILT_MODEL_CODE.VLM_HOJIN:
                                                    return <option key={item?.id} value={item?.id}>{t("documents_download.prebuilt_vlm_hojin")}</option>
                                                default:
                                                    return <option key={item?.id} value={item?.id}>{item?.configName}</option>
                                            }
                                        }
                                        return <option key={item?.id} value={item?.id}>{item?.configName}</option>
                                    })
                                }
                                {
                                    this.props?.documentsDownloadStore?.aiSettings.map((item) => {
                                        let id = `ai-setting,${item}`;
                                        let text = item == AI_SETTING_NONE ? t("documents_download.ai.no_setting") : item;
                                        return <option key={id} value={id}>{text}</option>
                                    })
                                }
                            </select>
                        </div>
                    </div>

                    <div className="row row-2nd">
                        <div style={{ display: "flex" }}>
                            <div style={{ lineHeight: "30px" }}>
                                <label>{t("download_search_box.registered_date")}</label>
                            </div>
                            <div className={"searchbox-dp " + (this.state.errors[DOWNLOAD_ACCESSOR_SEARCH_BOX.FROM_TIME] !== "" ? "error" : "")}>
                                <InputWrap customClass="registered-date-input-wrap">
                                    <div className="input-group date">
                                        <label className="date-label">
                                            <div className="input-group-addon">
                                                <i className="fa fa-calendar"></i>
                                            </div>
                                            <DateComponent placeholder={DATE_PLACHOLDER_FORMAT} name={DOWNLOAD_ACCESSOR_SEARCH_BOX.FROM_TIME} onChange={this.handleFilterDataChange}
                                                value={this.props.documentsDownloadStore?.tempFilterData?.fromTime} maxDate={new Date()} />
                                        </label>
                                    </div>
                                    <span className="color-red">{t(this.state.errors[DOWNLOAD_ACCESSOR_SEARCH_BOX.FROM_TIME])}</span>
                                </InputWrap>
                            </div>
                            <div className="sb-dp-separate">
                                <label>{DATE_SEPARATE}</label>
                            </div>
                            <div className={"searchbox-dp " + (this.state.errors[DOWNLOAD_ACCESSOR_SEARCH_BOX.TO_TIME] !== "" ? "error" : "")}>
                                <InputWrap>
                                    <label className="hideLabel">{t("download_search_box.to_date")}</label>
                                    <div className="input-group date ">
                                        <label className="date-label">
                                            <div className="input-group-addon">
                                                <i className="fa fa-calendar"></i>
                                            </div>
                                            <DateComponent placeholder={DATE_PLACHOLDER_FORMAT} name={DOWNLOAD_ACCESSOR_SEARCH_BOX.TO_TIME} onChange={this.handleFilterDataChange}
                                                value={this.props.documentsDownloadStore?.tempFilterData?.toTime} maxDate={new Date()} />
                                        </label>
                                    </div>
                                </InputWrap>
                                <span className="color-red">{t(this.state.errors[DOWNLOAD_ACCESSOR_SEARCH_BOX.TO_TIME])}</span>
                            </div>
                        </div>

                        <div className="l10">
                            <label>{t("download_search_box.team_name")}</label>
                            <select className="select download-select"
                                onChange={(e) => this.handleFilterDataChange(DOWNLOAD_ACCESSOR_SEARCH_BOX.TEAM_ID, e?.target?.value)}
                                value={this.props.documentsDownloadStore.tempFilterData?.teamId ? this.props.documentsDownloadStore.tempFilterData?.teamId : ""}>
                                <option key={"null"} value={"null"}>{t("download_search_box.all_definition_file")}</option>
                                {
                                    teamStore.teamsOfUser?.map((team) => {
                                        return <option key={team?.id} value={team?.id}>{team?.name}</option>
                                    })
                                }
                            </select>
                        </div>
                        <div className="l10">
                            <label>{t("download_search_box.user_id")}</label>
                            <select className="select download-select"
                                onChange={(e) => this.handleFilterDataChange(DOWNLOAD_ACCESSOR_SEARCH_BOX.USER_ID, e?.target?.value)}
                                value={this.props.documentsDownloadStore.tempFilterData?.userId ? this.props.documentsDownloadStore.tempFilterData?.userId : ""}>
                                <option key={"null"} value={"null"}>{t("download_search_box.all_definition_file")}</option>
                                {
                                    teamStore.usersInSameTeams?.map((user) => {
                                        return <option key={user?.userId} value={user?.userId}>{user?.userId}</option>
                                    })
                                }
                            </select>
                        </div>
                    </div>

                    <div className="row row-3rd">
                        <div>
                            <label className="lbl-status">{t("download_search_box.status")}</label>
                        </div>
                        <div>
                            <InputCheckbox
                                id={DOWNLOAD_ACCESSOR_SEARCH_BOX.STATUS_NOT_DOWNLOADED}
                                type="checkbox"
                                label={t("download_search_box.not_downloaded")}
                                onChange={(e) => this.handleFilterDataChange(DOWNLOAD_ACCESSOR_SEARCH_BOX.STATUS_NOT_DOWNLOADED, e?.target?.checked)}
                                checked={this.props.documentsDownloadStore?.tempFilterData?.notDownloaded ? true : false}
                            />
                            <InputCheckbox
                                id={DOWNLOAD_ACCESSOR_SEARCH_BOX.STATUS_DOWNLOADED}
                                type="checkbox"
                                label={t("download_search_box.downloaded")}
                                onChange={(e) => this.handleFilterDataChange(DOWNLOAD_ACCESSOR_SEARCH_BOX.STATUS_DOWNLOADED, e?.target?.checked)}
                                checked={this.props.documentsDownloadStore?.tempFilterData?.downloaded ? true : false}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(SearchBox);
